// extracted by mini-css-extract-plugin
export default {"noticeContainer":"_19vN1","newNotice":"_0YINf","noticeBody":"_5ihPK","infoGroup":"WBjCL","userNickname":"ip8L5","commentDate":"VLHeO","recordTags":"kTXTz","tag":"Hz+BA"};